module.exports = __webpack_public_path__ + "img/icon_body.6da67c05.png";